import React from "react";
import { Header } from "../components/Header";
import { VideoSection } from "../components/VideoSection";
import { Footer } from "../components/Footer";

export default function VideosPage() {
  return (
    <div className="min-h-screen bg-[var(--page-bg)] text-[var(--brand-ink)]" data-testid="page-videos">
      <Header />
      <VideoSection />
      <Footer />
    </div>
  );
}
